import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function EditorialHeader() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  return (
      <header className="about-header about-wrap">
        <Link className="about-wordmark" to="/" aria-label="Leravyn">LERAVYN<span>ENERGY · WIND · LIBERTY</span></Link>
        <nav className="about-nav" aria-label={t("about.design.navigation")}>
          {[["/", "home"], ["/about", "about"], ["/services", "services"], ["/contact", "contact"]].map(([path, key]) => (
            <Link key={path} to={path} aria-current={location.pathname === path ? "page" : path === "/services" && location.pathname.startsWith("/service/") ? "location" : undefined}>{t(`nav.${key}`)}</Link>
          ))}
        </nav>
        <div className="about-languages" role="group" aria-label={t("about.design.language")}>
          {[ ["en", "EN", "English"], ["ru", "RU", "Русский"] ].map(([code, label, name]) => (
            <button key={code} type="button" lang={code} aria-label={name} aria-pressed={i18n.resolvedLanguage === code} onClick={() => i18n.changeLanguage(code)}>{label}</button>
          ))}
        </div>
      </header>
  );
}
